import { useEffect, useState } from "react";
import Checkbox, { CheckboxChangeEvent } from "antd/lib/checkbox";

interface FilterCheckboxProps {
    fieldName: 'isInStock' | 'isExisted' | 'hasGoodsDayPhoto';
    checked?: boolean;
    label: string;
    dispatchGridFilter: (action: any) => void;
    resetKey?: number;
}

export const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ fieldName, checked, label, dispatchGridFilter, resetKey }) => {

    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        if (resetKey !== undefined) {
            setIsChecked(false);
            dispatchGridFilter({ type: "deleteColumnFilter", payload: fieldName });
        }
    }, [resetKey]);
    
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleChange = (e: CheckboxChangeEvent) => {
        const newChecked = e.target.checked;
        setIsChecked(newChecked);
        
        if (newChecked) {
            dispatchGridFilter({
                type: 'addColumnFilter',
                payload: {
                    name: fieldName,
                    operator: 'Eq',
                    value: true
                },
            });
        } else {
            dispatchGridFilter({ type: "deleteColumnFilter", payload: fieldName });
        }
    };
    
    return (
        <Checkbox
            checked={isChecked}
            onChange={handleChange}
        >
            {label}
        </Checkbox>
    );
};